<template>
  <div class="input-group-head">
    <div :class="['input-group-head__label', { large }]">
      {{ label }}
    </div>
    <div
      v-if="!!error"
      class="input-group-head__error error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-group-head',

  props: {
    label: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: '',
    }
  }
}
</script>

<style lang="scss">
  .input-group-head {
    &__label {
      display: inline-block;
      font-size: 14px;
      line-height: 20px;
      margin-right: 8px;

      &.large {
        font-weight: 600;
      }
    }

    &__error {
      display: inline-block;
      color: $red;
      font-size: 12px;
      line-height: 16px;
    }
  }
</style>
